import { StyleSheet, Text, View } from "react-native";
import React from "react";
import { ScrollView } from "react-native";
import Colours from "../../utils/Colours";
import PublicProfileBody from "./PublicProfileBody";
import { useNavigation, useRoute } from "@react-navigation/native";

const PublicProfile = ({ setShowPublicProfile }) => {
  const route = useRoute();
  const { userData } = route.params;
  const navigation = useNavigation();
  return (
    <ScrollView
      style={styles.componentStyle}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
      showsVerticalScrollIndicator={false}
    >
      <PublicProfileBody userData={userData} />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
});

export default PublicProfile;
